import * as builder from "_metronic/ducks/builder";
import * as i18n from "_metronic/ducks/i18n";

/**
 * Reexports
 */
export { default as mockAxios } from "_metronic/__mocks__/mockAxios";
export { default as I18nProvider } from "_metronic/i18n/I18nProvider";
export * from "_metronic/layout/LayoutConfig";
export { default as LayoutConfig } from "_metronic/layout/LayoutConfig";
export * from "_metronic/layout/LayoutContext";
export { default as LayoutInitializer } from "_metronic/layout/LayoutInitializer";
export { default as customTheme } from "_metronic/materialUIThemeProvider/ThemeProvider";
export * from "_metronic/utils/utils";

/**
 * Ducks
 */

export const metronic = { i18n, builder };
